'use strict';

import $ from 'jquery';
import setNextUrl from '../../utils/setNextUrl';

const VALID_EMAIL_REGEX = /^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i;
const DEFAULT_NEXT_URL = `${window.location.origin}/register`;

export default function confirmEmail() {
  const $inputMail = $('#email');
  const $btnNext = $('#next');
  const $invalidMessage = $inputMail.siblings('.invalid-feedback');
  const $ssoConfirmBox = $('#sso-box');
  let isValidEmail = false;

  function setEmailValidity(email) {
    isValidEmail = VALID_EMAIL_REGEX.test(email);
    if (isValidEmail) {
      $inputMail.removeClass('is-invalid');
      $invalidMessage.removeClass('is-invalid');
    } else {
      $inputMail.addClass('is-invalid');
      $invalidMessage.addClass('is-invalid');
    }
  }

  function handleSSOBox(nextURL) {
    if (nextURL !== DEFAULT_NEXT_URL) {
      $ssoConfirmBox.show();
    } else {
      $ssoConfirmBox.hide();
    }
  }

  function updateNextUrl() {
    const email = $inputMail.val().trim();
    const nextUrl = setNextUrl(email, DEFAULT_NEXT_URL);
    handleSSOBox(nextUrl);
    $btnNext.attr('href', nextUrl);
  }

  $inputMail.on('keyup', updateNextUrl).on('blur', function () {
    const email = $(this).val().trim();
    if (!email) {
      return;
    }
    setEmailValidity(email);
  });

  $btnNext.on('click', function (event) {
    const email = $inputMail.val().trim();
    setEmailValidity(email);
    if (!isValidEmail) {
      event.preventDefault();
      return false;
    }
    localStorage.setItem('emailDV', email);
  });
}
